<template>
  <div class="px-5">
    <portal to="portal-menu-principal-topbar" tag="div">
      <GrupoCompra class="ml-7" />

      <v-btn title="Mudar orientação da tela" class="ml-2" icon @click="mudarOrientacaoVisaoTela">
        <v-icon size="20">mdi-screen-rotation</v-icon>
      </v-btn>

      <FiltrosSysCategorias @update:filtros="filtros => (filtros_sys_categorias = filtros)" />

      <!-- <VincularCategoriasAFiltros /> -->

      <ListaCategoriasSilenciadas class="mt-2" />

      <v-spacer />

      <Carrinho />
    </portal>

    <div class="d-flex align-center px-2">
      <h3 class="ml-n2">Compras/Matéria prima</h3>

      <v-spacer />

      <CardsTotalizadores :filtros_sys_categorias="filtros_sys_categorias" />
    </div>

    <div :class="{'d-flex': VISAO_VERTICAL_ATIVA}">
      <GridPrincipal
        :filtros_sys_categorias="filtros_sys_categorias"
        :class="{
          'w-54-porcento': VISAO_VERTICAL_ATIVA,
          'position-absolute mt-291px w-full ml-n5 px-5': !VISAO_VERTICAL_ATIVA,
        }"
      />

      <div
        class="detalhes-categorias"
        :class="{
          'w-46-porcento ml-2': VISAO_VERTICAL_ATIVA,
          'w-full': !VISAO_VERTICAL_ATIVA
        }"
        :style="{height: VISAO_VERTICAL_ATIVA ? 'calc(100vh - 153px)' : '275px'}"
      >
        <DetalhesCategoria v-if="categoria_selecionada" />
        <Indicadores v-else />
        <v-divider v-show="!VISAO_VERTICAL_ATIVA" class="mt-8px" />
      </div>
    </div>
  </div>
</template>

<script>
import Carrinho from "./Carrinho/Index.vue";
import Indicadores  from './Indicadores/Index.vue';
import GridPrincipal from "./GridPrincipal";
import CardsTotalizadores from "./CardsTotais/Index.vue";
import { categoria_selecionada } from "./Helpers/CategoriaSelecionado.js";
import DetalhesCategoria from "./DetalhesCategoria/Index.vue";
import GrupoCompra from "@/components/compra/materiaPrima/compra/GrupoCompra";
// import VincularCategoriasAFiltros from "@/components/compra/materiaPrima/compra/FiltrosSysCategorias/VincularCategoriasAFiltros";
import FiltrosSysCategorias from "@/components/compra/materiaPrima/compra/FiltrosSysCategorias/Index";
import ListaCategoriasSilenciadas
  from "@/components/compra/materiaPrima/compra/Silenciar/ListaCategoriasSilenciadas.vue";

export default {
  name: "Index.vue",
  mixins: [categoria_selecionada],
  components: {
    ListaCategoriasSilenciadas,
    FiltrosSysCategorias,
    GrupoCompra,
    CardsTotalizadores,
    Carrinho,
    Indicadores,
    GridPrincipal,
    DetalhesCategoria,
    // VincularCategoriasAFiltros
  },
  data: () => ({
    filtros_sys_categorias: []
  }),
  computed: {
    VISAO_VERTICAL_ATIVA: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getVisaoVertical'];
      },
      set: function (valor) {
        localStorage.config_orientacao_vertical_tela_compras = valor ? 'S' : 'N';
        return this.$store.dispatch('CompraProdutosGerais/setVisaoVertical', valor);
      }
    },
  },
  methods: {
    mudarOrientacaoVisaoTela() {
      this.VISAO_VERTICAL_ATIVA = ! this.VISAO_VERTICAL_ATIVA;
    }
  }
}
</script>

<style scoped>
.mt-291px {
  margin-top: 291px;
}
.detalhes-categorias {
  box-shadow: 0 1px 1px rgba(181, 181, 181, 0.82);
  border-radius: 8px;
}
</style>
